// Site configuration
export const siteConfig = {
  foundingProperties: {
    total: 30
  },
  contact: {
    email: "info@reflow.rent"
  }
};
